import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  RxFormBuilder,
  RxwebValidators,
} from '@rxweb/reactive-form-validators';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { GoogleMapDialogBoxComponent } from './google-map-dialog-box/google-map-dialog-box.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReplaySubject, Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { take, takeUntil } from 'rxjs/operators';
import { YoutubeDialogBoxComponent } from './youtube-dialog-box/youtube-dialog-box.component';
import { BrochureViewComponent } from '../../startup-page/incubators-details/brochure-view/brochure-view.component';
declare let $: any;
interface incubDis {
  district: string;
}

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.css'],
})
export class ProfilePageComponent implements OnInit {
  profileForm: FormGroup;
  private saveApi = environment.url + environment.profileSave;
  private getApi = environment.url + environment.profileGet;
  private getApis = environment.url + environment.adminprofileGet;
  private videoSaveApi = environment.url + environment.incubatorVideoSave;
  private fundingDeleteApi = environment.url + environment.fundingDelete;
  private SponsorshipDeleteApi =
    environment.url + environment.sponsorShipDelete;
  private removeBrouchure = environment.url + environment.removeBrouchure;
  incubatorIds = sessionStorage.getItem('incubatorId');
  userIds = sessionStorage.getItem('userId');
  districtdataList: string[] = [
    'Ariyalur',
    'Chengalpattu',
    'Chennai',
    'Coimbatore',
    'Cuddalore',
    'Dharmapuri',
    'Dindigul',
    'Erode',
    'Kallakurichi',
    'Kanchipuram',
    'Kanniyakumari',
    'Karur',
    'Krishnagiri',
    'Madurai',
    'Mayiladuthurai',
    'Nagapattinam',
    'Namakkal',
    'Nilgiris',
    'Perambalur',
    'Pudukkottai',
    'Ramanathapuram',
    'Ranipet',
    'Salem',
    'Sivagangai',
    'Tenkasi',
    'Thanjavur',
    'Theni',
    'Thoothukudi',
    'Tiruchirappalli',
    'Tirunelveli',
    'Tirupathur',
    'Tiruppur',
    'Tiruvallur',
    'Tiruvannamalai',
    'Tiruvarur',
    'Vellore',
    'Viluppuram',
    'Virudhunagar',
    'Other',
  ];
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private httpClient: HttpClient
  ) {
    this.profileForm = this.fb.group({
      // "userId": this.roleValue === 'Admin' ?  this.incubatorIds : this.userIds,
      // "userId": this.roleValue === 'Admin' ?  1 : 2,
      username: ['', [Validators.required]],
      uniqueId: ['', [Validators.required]],
      // incubator
      // "incubatorName": ['', [Validators.required,Validators.pattern('^[a-zA-Z][a-zA-Z./ ]*$')],],
      incubatorName: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9][a-zA-Z0-9./ ]*$'),
        ],
      ],
      email: ['', [Validators.required, Validators.email]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      incubatorYearofEstd: ['', [Validators.required]],
      incubatorFocusedSector: ['', [Validators.required]],
      incubatorArea: ['', [Validators.required]],
      incubatorLogoFile: [''],
      incubatorLogoFileName: [''],
      incubatorDistrict: ['', [Validators.required]],
      incubatorRegistrationType: ['', [Validators.required]],
      incubatorRegistrationTypeOther: [''],
      incubatorRegDesc: ['', [Validators.required]],
      incubatorRegFileName: ['', [Validators.required]],
      incubatorRegFile: [''],
      // Facilities
      incubatorFacilities: ['', [Validators.required]],
      coworkingSpace: [''],
      fablabMakerSpace: [''],
      focusSectorLaboratories: [''],
      salesKioskIncubatees: [''],
      trainingSeminarHall: [''],
      // incubatorTeams
      incubatorTeamNameTitle: ['', [Validators.required]],
      incubatorTeamFirstName: ['', [Validators.required]],
      incubatorTeamLastName: [''],
      incubatorTeamDesignation: ['', [Validators.required]],
      incubatorTeamPhone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      incubatorTeamLinkedin: ['', [Validators.required]],
      incubatorTeamSize: ['', [Validators.required]],
      incubatorTeamAddlManpower: ['', [Validators.required]],
      incubatorTeamEmail: ['', [Validators.required, Validators.email]],
      // HostInstitution
      incubatorHostInstitution: ['', [Validators.required]],
      incubatorRegAddressLine1: ['', [Validators.required]],
      incubatorRegAddressLine2: [''],
      incubatorRegCity: ['', [Validators.required]],
      incubatorRegState: ['', [Validators.required]],
      incubatorRegZipcode: [
        '',
        [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{6,6}$')],
      ],
      // operational
      operationalAddressFlag: [''],
      incubatorOprAddressLine1: [''],
      incubatorOprAddressLine2: [''],
      incubatorOprCity: [''],
      incubatorOprState: [''],
      incubatorOprZipcode: [''],
      incubatorHostPhone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      incubatorHostEmail: ['', [Validators.required, Validators.email]],
      // Funding
      incubatorFunding: new FormArray([]),
      incubatorSponsorship: new FormArray([]),
      // Branch
      incubatorBranchAvail: ['', [Validators.required]],
      incubatorBranch: [''],
      // Mentor
      incubatorMentorProgAvail: ['', [Validators.required]],
      incubatorMentorReg: [''],
      // social
      incubatorWebsite: [''],
      incubatorLinkedin: [''],
      incubatorFacebook: [''],
      incubatorTwitter: [''],
      incubatorInstagram: [''],
      // others
      incubatorProvidedSchemes: ['', [Validators.required]],
      incubatorBrouchureFile: [''],
      incubatorBrouchureName: [''],
      incubatorHasIpPolicy: ['', [Validators.required]],
      incubatorOfferPreIncProg: ['', [Validators.required]],
      incubatorHasStudStartupPol: ['', [Validators.required]],
      incubatorHasTechTransPol: ['', [Validators.required]],
      specialReceivedIncubator: ['', [Validators.required]],
      googleMap: [''],
      shortVideo: [''],
      youtubeVideoLink: [''],
      // inubatee details
      incubateesCount: ['', [Validators.required]],
      incubateesDPIITRecogCount: ['', [Validators.required]],
      incubateesSCSTFoundersCount: [''],
      incubateesPhysicalSpaceCount: ['', [Validators.required]],
      incubateesVirtualSpaceCount: ['', [Validators.required]],
      // "incubatorFocusedDistricts": ['',],
      incubateesGraduatedStartupsCount: [''],
      incubateesComments: [''],
      incubateesSupportRequiredComments: [''],
      incubateesWomenFoundersCount: [''],
    });
  }
  get add() {
    return this.profileForm.controls;
  }
  get fundingList() {
    return this.profileForm.get('incubatorFunding') as FormArray;
  }
  get SponsorshipList() {
    return this.profileForm.get('incubatorSponsorship') as FormArray;
  }
  proReg: any;
  roleValue: any;

  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
    this.yearGetList();
    this.districtList();
    this.roleValue = sessionStorage.getItem('role');
    // this.croReg = sessionStorage.getItem('profileRegCorporate')
    this.proReg = sessionStorage.getItem('profileReg');
    // if(this.proReg=='Yes'){
    //   this.profileGet()
    // }else{
    //   this.fundingList.push(this.fb.group({
    //     "incubatorFundingAgencyType": [''],
    //     "incubatorFundingAgencyTypeOther": [''],
    //     "incubatorFundingAgencyName": [''],
    //   }))
    // }
    if (this.roleValue === 'Incubator' || this.roleValue === 'Admin') {
      this.profileGet();
    }
    let getform = this.profileForm.value;
    this.profileForm.patchValue(getform);
    // .subscribe(params => {
    //
    //   //  this.sample =  params._districtname
    //    let getform=this.profileForm.value
    //   //  getform.incubatorDistrict=params._districtname
    //    this.profileForm.patchValue(getform)
    //    this.selectIncubator(params._districtname)
    //
    //   // this.newsletterlistApi(params._districtname)
    // })
  }
  // districtValues = []
  // districtList() {
  //   this.httpClient.get<any>('assets/json/district.json').subscribe(data => {
  //     this.districtValues = data
  //     this.incubatorDistrictList = this.districtValues
  //     this.filterIncubetorDistrict()
  //   })
  // }
  districtValues = [];
  districtList() {
    this.httpClient.get<any>('assets/json/district.json').subscribe((data) => {
      this.districtValues = data;
      this.incubatorDistrictList = this.districtValues;
      this.filterIncubetorDistrict();
    });
  }
  searchValue = false;
  searchList = [];
  list: any = {};
  selectIncubator(value) {
    this.searchValue = true;
    this.searchList = [];
    let getform = this.profileForm.value;
    this.list = {
      incubatorName: getform.incubatorName,
      incubatorYearofEstd: getform.incubatorYearofEstd,
      incubatorDistrict: getform.incubatorDistrict,
      incubatorFocusedSector: getform.incubatorFocusedSector,
      // "pageNumber": this.currentPage,
      // "listSize": this.currentPageCount
    };

    // this.listApi()
  }
  yearData = [];
  yearGetList() {
    let val = 1978;
    const d = new Date();
    let year = d.getFullYear();
    for (let i = year; i >= val; i--) {
      if (val <= i) {
        this.yearData.push(i);
      }
    }
  }
  proFile;
  profileGet() {
    let apiUrl = '';
    if (this.roleValue === 'Incubator') {
      const username = sessionStorage.getItem('username');
      apiUrl = this.getApi + '?username=' + username;
    } else if (this.roleValue === 'Admin') {
      const userId = sessionStorage.getItem('incubatorId');
      apiUrl = this.getApis + '?id=' + userId;
    }
    if (apiUrl) {
      this.getdata.amizhthLoader('show');
      // let username = sessionStorage.getItem('username')
      this.makeapi.method(apiUrl, '', 'get').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.proFile = data;
        if (data.incubatorFunding == undefined) {
          this.fundingList.push(
            this.fb.group({
              id: [''],
              incubatorFundingAgencyType: [''],
              incubatorFundingAgencyTypeOther: [''],
              incubatorFundingAgencyName: [''],
            })
          );
        } else {
          for (let i = 0; i < data.incubatorFunding.length; i++) {
            this.fundingList.push(
              this.fb.group({
                id: [''],
                incubatorFundingAgencyType: [''],
                incubatorFundingAgencyTypeOther: [''],
                incubatorFundingAgencyName: [''],
              })
            );
            let val = data.incubatorFunding[i].incubatorFundingAgencyType;
            if (val == 'Other') {
              this.checkAgencyType(val, i);
            }
          }
        }
        if (data.incubatorSponsorship == undefined) {
          this.SponsorshipList.push(
            this.fb.group({
              id: [''],
              incubatorSponsorshipAgencyType: [''],
              incubatorSponsorshipAgencyTypeOther: [''],
              incubatorSponsorshipAgencyName: [''],
            })
          );
        } else {
          for (let i = 0; i < data.incubatorSponsorship.length; i++) {
            this.SponsorshipList.push(
              this.fb.group({
                id: [''],
                incubatorSponsorshipAgencyType: [''],
                incubatorSponsorshipAgencyTypeOther: [''],
                incubatorSponsorshipAgencyName: [''],
              })
            );
            let val =
              data.incubatorSponsorship[i].incubatorSponsorshipAgencyType;
            if (val == 'Other') {
              this.checkSponsorshipType(val, i);
            }
          }
        }
        this.profileForm.patchValue(data);
        // reg docu
        if (data.incubatorRegFileName != undefined) {
          //
          this.RegdisName = '✔ Uploaded';
          this.RegFileValue = data.incubatorRegFileName;
          this.RegFileName = data.incubatorRegFileName;
        }
        // incubatorFacilities code
        if (data.incubatorYearofEstd != null) {
          let spli = data.incubatorFacilities;
          let nameArr = spli.split(',');
          nameArr.forEach((element) => {
            this.selectedFacilities.push(element);
            let getform = this.profileForm.value;
            if (element == 'Co-working space') {
              getform.coworkingSpace = true;
            }
            if (element == 'Fablab/MakerSpace') {
              getform.fablabMakerSpace = true;
            }
            if (element == 'Focus Sector Laboratories') {
              getform.focusSectorLaboratories = true;
            }
            if (element == 'Sales Kiosk for Incubatees') {
              getform.salesKioskIncubatees = true;
            }
            if (element == 'Training/Seminar Hall') {
              getform.trainingSeminarHall = true;
            }
            // this.selectedFacilities.push(element)
            this.profileForm.patchValue(getform);
          });
          // incubatorRegistrationType code
          if (data.incubatorRegistrationType == 'Other') {
            this.selectRegistrationType(data.incubatorRegistrationType);
          }
          // incubatorOprAddress code
          if (
            data.incubatorOprAddressLine1 != '' &&
            data.incubatorOprAddressLine1 != undefined
          ) {
            let getform = this.profileForm.value;
            getform.operationalAddressFlag = true;
            this.operationalAdd = true;
            this.profileForm.patchValue(getform);
          }
          // incubatorBranchAvail code
          if (data.incubatorBranchAvail == 'Yes') {
            this.showBranchOptions('Yes');
          }
          // incubatorMentorProgAvail code
          if (data.incubatorMentorProgAvail == 'Yes') {
            this.showMentoringOptions('Yes');
          }
          // incubatorBrouchureName code
          if (data.incubatorBrouchureName != undefined) {
            this.disName = '✔ Uploaded';
            this.FileValue = data.incubatorBrouchureFile;
            this.FileName = data.incubatorBrouchureName;
          }

          // if (data.shortVideo != '') {
          //   this.disVideoName = "✔ Uploaded"
          // }
          if (data.incubatorFundingAgencyType == 'Other') {
            this.checkAgencyType('Other', 0);
          }
          if (data.incubatorSponsorshipAgencyType == 'Other') {
            this.checkSponsorshipType('Other', 0);
          }
          // incubatorLogoFile code
          // if (data.incubatorLogoFileName != null) {
          //   this.image_url = data.incubatorLogoFileName
          //   this.ImageValue = data.incubatorLogoFile
          //   this.img_name = data.incubatorLogoFileName
          // } else {
          //   this.image_url = 'assets/images/photo.png'
          // }
          if (data.incubatorLogoFileName != null) {
            this.image_urls = data.incubatorLogoFileName;
            this.ImageValues = data.incubatorLogoFile;
            this.img_names = data.incubatorLogoFileName;
          } else {
            this.image_urls = 'assets/images/photo.png';
          }
        }
      });
    }
  }
  showOtherRegType = false;
  selectRegistrationType(value) {
    let val = value;
    if (val == 'Other') {
      this.showOtherRegType = true;
      this.profileForm.controls['incubatorRegistrationTypeOther'].setValidators(
        [Validators.required]
      );
    } else {
      this.showOtherRegType = false;
      this.profileForm.controls['incubatorRegistrationTypeOther'].setValue('');
      this.profileForm.controls[
        'incubatorRegistrationTypeOther'
      ].clearValidators();
    }
    this.profileForm.controls[
      'incubatorRegistrationTypeOther'
    ].updateValueAndValidity();
  }
  operationalAdd = false;
  showOperationalAddress(event) {
    this.operationalAdd = event.checked;
    if (this.operationalAdd == true) {
      this.profileForm.controls['incubatorOprAddressLine1'].setValidators([
        Validators.required,
      ]);
      this.profileForm.controls['incubatorOprCity'].setValidators([
        Validators.required,
      ]);
      this.profileForm.controls['incubatorOprState'].setValidators([
        Validators.required,
      ]);
      this.profileForm.controls['incubatorOprZipcode'].setValidators([
        Validators.required,
      ]);
    } else {
      this.profileForm.controls['incubatorOprAddressLine1'].setValue('');
      this.profileForm.controls['incubatorOprCity'].setValue('');
      this.profileForm.controls['incubatorOprState'].setValue('');
      this.profileForm.controls['incubatorOprZipcode'].setValue('');
      this.profileForm.controls['incubatorOprAddressLine1'].clearValidators();
      this.profileForm.controls['incubatorOprCity'].clearValidators();
      this.profileForm.controls['incubatorOprState'].clearValidators();
      this.profileForm.controls['incubatorOprZipcode'].clearValidators();
    }
    this.profileForm.controls[
      'incubatorOprAddressLine1'
    ].updateValueAndValidity();
    this.profileForm.controls['incubatorOprCity'].updateValueAndValidity();
    this.profileForm.controls['incubatorOprState'].updateValueAndValidity();
    this.profileForm.controls['incubatorOprZipcode'].updateValueAndValidity();
  }
  Mentorchecked = '';
  showMentoringOptions(value) {
    this.Mentorchecked = value;
    if (this.Mentorchecked == 'Yes') {
      this.profileForm.controls['incubatorMentorReg'].setValidators([
        Validators.required,
      ]);
    } else {
      this.profileForm.controls['incubatorMentorReg'].setValue('');
      this.profileForm.controls['incubatorMentorReg'].clearValidators();
    }
    this.profileForm.controls['incubatorMentorReg'].updateValueAndValidity();
  }
  Branchchecked = '';
  showBranchOptions(value) {
    this.Branchchecked = value;
    if (this.Branchchecked == 'Yes') {
      this.profileForm.controls['incubatorBranch'].setValidators([
        Validators.required,
      ]);
    } else {
      this.profileForm.controls['incubatorBranch'].setValue('');
      this.profileForm.controls['incubatorBranch'].clearValidators();
    }
    this.profileForm.controls['incubatorBranch'].updateValueAndValidity();
  }
  // ImageValue: any = []
  // imgFormat: any
  // selecetdImage: File
  // imagetype: any
  // fileValue: File
  // url1: any = 'assets/images/photo.png'
  // img_name = ''
  // image_url: any = 'assets/images/photo.png'
  // image_urls: any = 'assets/images/photo.png'
  // img: any
  // onSelectImage(event) {
  //   this.selecetdImage = event.target.files[0];
  //   if (event.target.files && this.selecetdImage) {
  //     let reader = new FileReader();
  //     let data = this.selecetdImage
  //     this.imagetype = data.type
  //     let imagedatatype = this.imagetype.split("/")
  //     let img_crt_type = imagedatatype[1]
  //     if (img_crt_type == "jpeg" || img_crt_type == "jpg" || img_crt_type == "png" || img_crt_type == "webp") {
  //       this.img = ''
  //       this.fileValue = this.selecetdImage
  //       reader.readAsDataURL(this.fileValue);
  //       reader.onload = () => {
  //         let splType = this.selecetdImage.type.split('/')
  //         this.url1 = reader.result;
  //         let spl = this.url1.split(',')
  //         this.ImageValue = spl[1]
  //         // this.imgFormat = splType[1]
  //         this.img_name = this.fileValue.name
  //         this.logoCheck = false
  //         this.image_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.url1);
  //       }
  //     } else {
  //       this.img = 'show'
  //     }
  //   }
  // }
  ImageValues: any = [];
  imgFormat: any;
  selecetdImage: File;
  imagetype: any;
  fileValue: File;
  url1: any = 'assets/images/photo.png';
  img_names = '';
  image_urls: any = 'assets/images/photo.png';
  img: any;
  logoCheck = false;
  maxSizeMB = 10;
  onSelectImage(event) {
    this.selecetdImage = event.target.files[0];
    if (event.target.files && this.selecetdImage) {
      const fileSizeMB = this.selecetdImage.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.logoCheck = true;
        // this.notify.notifyError('File size exceeds the limit (10MB)');
        return;
      }

      let reader = new FileReader();
      let data = this.selecetdImage;
      this.imagetype = data.type;
      let imagedatatype = this.imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png'
      ) {
        // || img_crt_type == "webp"
        this.img = '';
        this.fileValue = this.selecetdImage;
        reader.readAsDataURL(this.fileValue);
        reader.onload = () => {
          let splType = this.selecetdImage.type.split('/');
          this.url1 = reader.result;
          let spl = this.url1.split(',');
          this.ImageValues = spl[1];
          // this.imgFormat = splType[1]
          this.img_names = this.fileValue.name;
          this.logoCheck = false;
          this.image_urls = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url1
          );
        };
      } else {
        this.img = 'show';
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  // agency code
  agencyType = false;
  agencyCss;
  checkAgencyType(value, i) {
    let val = value;
    //
    if (val == 'Other') {
      $(document).ready(function () {
        this.agencyCss = '.agencyType' + i;
        $(this.agencyCss).addClass('d-block');
      });
      this.fundingList.controls[i]
        .get('incubatorFundingAgencyTypeOther')
        .setValidators(Validators.required);
      //
    } else {
      $(document).ready(function () {
        this.agencyCss = '.agencyType' + i;
        $(this.agencyCss).removeClass('d-block');
      });
      this.fundingList.controls[i]
        .get('incubatorFundingAgencyTypeOther')
        .clearValidators();
    }
    this.fundingList.controls[i]
      .get('incubatorFundingAgencyTypeOther')
      .updateValueAndValidity();
  }
  addRow(i) {
    // if (this.fundingList.controls[i].touched == true && this.fundingList.valid) {
    //   this.fundingList.push(this.fb.group({
    //     "id": [''],
    //     "incubatorFundingAgencyType": ['', [Validators.required]],
    //     "incubatorFundingAgencyTypeOther": [''],
    //     "incubatorFundingAgencyName": [''],
    //   }))
    // } else {
    //   this.fundingList.markAllAsTouched()
    // }
    const addRowForm = this.fb.group({
      id: [''],
      incubatorFundingAgencyType: ['', [Validators.required]],
      incubatorFundingAgencyTypeOther: [''],
      incubatorFundingAgencyName: [''],
    });

    this.fundingList.push(addRowForm);
  }
  deleteRow(i, id) {
    if (id != '') {
      this.makeapi
        .method(this.fundingDeleteApi + id, '', 'delete')
        .subscribe((data) => {
          if (data.responseStatus == 'Success') {
            if (this.fundingList.length > 1) {
              this.fundingList.controls.splice(i, 1);
            } else {
              this.fundingList.controls.splice(i, 1);
              this.fundingList.push(
                this.fb.group({
                  id: [''],
                  incubatorFundingAgencyType: [''],
                  incubatorFundingAgencyTypeOther: [''],
                  incubatorFundingAgencyName: [''],
                })
              );
              this.agencyCss = '.agencyType' + i;
              $(this.agencyCss).removeClass('d-block');
            }
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        });
    } else {
      if (this.fundingList.length > 1) {
        this.fundingList.controls.splice(i, 1);
      } else {
        this.fundingList.controls.splice(i, 1);
        this.fundingList.push(
          this.fb.group({
            id: [''],
            incubatorFundingAgencyType: [''],
            incubatorFundingAgencyTypeOther: [''],
            incubatorFundingAgencyName: [''],
          })
        );
        this.agencyCss = '.agencyType' + i;
        $(this.agencyCss).removeClass('d-block');
      }
    }
  }
  // Sponsorship code
  SponsorshipType = false;
  SponsorshipCss;
  checkSponsorshipType(value, i) {
    let val = value;
    //
    if (val == 'Other') {
      $(document).ready(function () {
        this.SponsorshipCss = '.Sponsorship' + i;
        $(this.SponsorshipCss).addClass('d-block');
      });
      this.SponsorshipList.controls[i]
        .get('incubatorSponsorshipAgencyTypeOther')
        .setValidators(Validators.required);
      //
    } else {
      $(document).ready(function () {
        this.SponsorshipCss = '.Sponsorship' + i;
        $(this.SponsorshipCss).removeClass('d-block');
      });
      this.SponsorshipList.controls[i]
        .get('incubatorSponsorshipAgencyTypeOther')
        .clearValidators();
    }
    this.SponsorshipList.controls[i]
      .get('incubatorSponsorshipAgencyTypeOther')
      .updateValueAndValidity();
  }
  addSponsorshipRow(i) {
    //   if (this.SponsorshipList.controls[i].touched == true && this.SponsorshipList.valid) {
    //     this.SponsorshipList.push(this.fb.group({
    //       "id": [''],
    //       "incubatorSponsorshipAgencyType": ['', [Validators.required]],
    //       "incubatorSponsorshipAgencyTypeOther": [''],
    //       "incubatorSponsorshipAgencyName": [''],
    //     }))
    //   } else {
    //     this.SponsorshipList.markAllAsTouched()
    //   }
    // }
    const SponsorshipRow = this.fb.group({
      id: [''],
      incubatorSponsorshipAgencyType: ['', [Validators.required]],
      incubatorSponsorshipAgencyTypeOther: [''],
      incubatorSponsorshipAgencyName: [''],
    });

    this.SponsorshipList.push(SponsorshipRow);
  }
  deleteSponsorshipRow(i, id) {
    if (id != '') {
      this.makeapi
        .method(this.SponsorshipDeleteApi + id, '', 'delete')
        .subscribe((data) => {
          if (data.responseStatus == 'Success') {
            if (this.SponsorshipList.length > 1) {
              this.SponsorshipList.controls.splice(i, 1);
            } else {
              this.SponsorshipList.controls.splice(i, 1);
              this.SponsorshipList.push(
                this.fb.group({
                  id: [''],
                  incubatorSponsorshipAgencyType: [''],
                  incubatorSponsorshipAgencyTypeOther: [''],
                  incubatorSponsorshipAgencyName: [''],
                })
              );
              this.SponsorshipCss = '.SponsorshipType' + i;
              $(this.SponsorshipCss).removeClass('d-block');
            }
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        });
    } else {
      // this.agencyCss = '.agencyType' + i
      // $(this.agencyCss).removeClass('d-block')
      if (this.SponsorshipList.length > 1) {
        this.SponsorshipList.controls.splice(i, 1);
      } else {
        this.SponsorshipList.controls.splice(i, 1);
        this.SponsorshipList.push(
          this.fb.group({
            id: [''],
            incubatorSponsorshipAgencyType: [''],
            incubatorSponsorshipAgencyTypeOther: [''],
            incubatorSponsorshipAgencyName: [''],
          })
        );
        this.SponsorshipCss = '.SponsorshipType' + i;
        $(this.SponsorshipCss).removeClass('d-block');
      }
    }
  }
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  // fileUpload
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      const fileSizeMB = this.selecetdFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        // this.logoCheck = true;
        // this.fileErrorShow = true
        this.notify.notifyError('File size exceeds the limit (10MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.notify.notifysuccess('File Upload Success !');
          this.FileName = this.selecetdFile.name;
          this.disName = this.selecetdFile.name;
        };
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  selecetdRegFile: any = [];
  urlReg: any;
  RegFileValue: any = '';
  RegFileName: any;
  documentRegValues = [];
  RegdisName;
  maxSizeMBs = 10;
  fileRegUpload(event) {
    this.selecetdRegFile = event.target.files[0];
    if (event.target.files && this.selecetdRegFile) {
      const fileSizeMB = this.selecetdRegFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMBs) {
        this.logoCheck = true;
        this.notify.notifyError('File size exceeds the limit (10MB)');
        return;
      }

      let reader = new FileReader();
      let imagetype = this.selecetdRegFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdRegFile);
        reader.onload = () => {
          this.urlReg = reader.result;
          let spl = this.urlReg.split(',');
          this.RegFileValue = spl[1];
          this.RegFileName = this.selecetdRegFile.name;
          this.RegdisName = this.selecetdRegFile.name;

          this.notify.notifysuccess('File Upload Success !');
          let getform = this.profileForm.value;
          getform.incubatorRegFileName = this.selecetdRegFile.name;
          getform.incubatorRegFile = this.RegFileValue;

          this.profileForm.patchValue(getform);
        };
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formets are allowed'
        );
      }
    }
  }
  deleteRegImage() {
    this.RegFileValue = '';
    this.RegFileName = '';
    this.RegdisName = '';
    // this.notify.notifyError('Brouchure Removed Successfully')
  }
  openYoutubeDialog() {
    this.dialog.open(YoutubeDialogBoxComponent, { width: '390px' });
  }
  checkTrue = false;
  checkFacilities(event, value) {
    let getform = this.profileForm.value;
    if (event == true) {
      this.selectedFacilities.push(value);
    } else {
      const index = this.selectedFacilities.indexOf(value);
      if (index > -1) {
        this.selectedFacilities.splice(index, 1);
      }
    }
    getform.incubatorFacilities = this.selectedFacilities.toString();
    this.profileForm.patchValue(getform);
  }
  selectedFacilities = [];
  // logoCheck = false
  googleCheck = false;
  googleMapCheck(event) {
    this.googleCheck = false;
    let val = event.target.value;
    // let val = 'https://maps.app.goo.gl/maps/hPeu4bb2zzdqHyZA8'
    let data = val.split('/');
    if (data.length > 2 && data[2] != 'maps.app.goo.gl') {
      // this.profileForm.controls['googleMap'].setValue('');
      this.googleCheck = true;
    } else if (data.length == 1 && data[0] != '') {
      this.googleCheck = true;
    } else {
      this.googleCheck = false;
    }
  }
  deleteImage() {
    if (this.proFile.incubatorYearofEstd != null) {
      this.makeapi
        .method(this.removeBrouchure, '', 'delete')
        .subscribe((data) => {
          if (data.responseStatus == 'Success') {
            this.FileValue = '';
            this.FileName = '';
            this.disName = '';
            let getform = this.profileForm.value;
            getform.incubatorBrouchureFile = '';
            getform.incubatorBrouchureName = '';
            this.profileForm.patchValue(getform);
            this.notify.notifysuccess(data.responseMessage);
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        });
    } else {
      this.FileValue = '';
      this.FileName = '';
      this.disName = '';
      this.notify.notifyError('Brouchure Removed Successfully');
    }
  }
  saveProfile() {
    let getform = this.profileForm.value;
    getform.username = sessionStorage.getItem('username');

    this.profileForm.patchValue(getform);

    if (
      this.ImageValues == '' ||
      this.profileForm.invalid ||
      this.googleCheck == true
    ) {
      if (this.ImageValues == '') {
        this.logoCheck = true;
      }
      if (this.googleCheck == true) {
        getform.googleMap = '';
      }

      this.profileForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
      return;
    } else {
      this.logoCheck = false;
      let getform = this.profileForm.value;
      if (this.ImageValues != '') {
        getform.incubatorLogoFile = this.ImageValues;
        getform.incubatorLogoFileName = this.img_names;
      }
      if (this.FileValue != '') {
        getform.incubatorBrouchureFile = this.FileValue;
        getform.incubatorBrouchureName = this.FileName;
      }
      // this.profileForm.patchValue(getform)
      (getform.userId =
        this.roleValue === 'Admin' ? this.incubatorIds : this.userIds),
        this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
          if (data.responseStatus == 'Success') {
            sessionStorage.setItem('profileReg', 'Yes');
            // if (this.selecetdVideo != "") {
            //   this.videoSave()
            // } else {  }
            sessionStorage.removeItem('logo');

            // Temp stop Process
            // this.router.navigate(['admin', 'dashboard', sessionStorage.getItem('username'), {}]);
            if (this.roleValue === 'Admin') {
              this.router.navigate(['incubator-list', {}]);
            } else {
              this.router.navigate(['uploadcsrsdoc', {}]);
            }
            this.notify.notifysuccess(
              'Your profile details has been updated !!'
            );
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        });
    }
  }
  cancelReg() {
    this.profileForm.reset();
    this.router.navigate(['uploadcsrsdoc', {}]);
  }
  AdminBack() {
    this.profileForm.reset();
    this.router.navigate(['incubator-list', {}]);
  }
  openDialog() {
    this.dialog.open(GoogleMapDialogBoxComponent, { width: '390px' });
  }
  // District
  protected incubatorDistrictList: incubDis[] = [];
  public incubatorDistrict: FormControl = new FormControl();
  public incubatorDistrictFilterCtrl: FormControl = new FormControl();
  public incubatorDistrictListValue = new ReplaySubject(1);
  protected _onDisDestroy = new Subject();
  @ViewChild('DistrictSelect', { static: true }) DistrictSelect: MatSelect;
  filterIncubetorDistrict() {
    this.incubatorDistrict.setValue(this.incubatorDistrictList[1]);
    this.incubatorDistrictListValue.next(this.incubatorDistrictList);
    this.incubatorDistrictFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDisDestroy))
      .subscribe(() => {
        this.filterDistrict();
      });
  }

  protected filterDistrict() {
    if (!this.incubatorDistrictList) {
      return;
    }
    let search = this.incubatorDistrictFilterCtrl.value;
    if (!search) {
      this.incubatorDistrictListValue.next(this.incubatorDistrictList.slice());
      return;
    } else {
      search = search;
    }
    this.incubatorDistrictListValue.next(
      this.incubatorDistrictList.filter(
        (val) => val.district.toLowerCase().indexOf(search) > -1
      )
    );
  }
}
